export default "__VITE_ASSET__CpnHDqek__"